import {web3} from 'decentralized/web3.js';
import {lstorage} from 'utils/lstorage.js';

let cache = {};

export const getBlockDate = async (blockNumber) => {
    let storage = lstorage;
    if (storage.getItem('blockDate.' + blockNumber)) {
        return new Date(storage.getItem('blockDate.' + blockNumber) * 1000);
    }
    if (blockNumber === undefined) {
        return undefined;
    }
    let block = await web3.eth.getBlock(blockNumber);
    if (block === null) {
        return new Date();
    }
    let date = new Date(block.timestamp * 1000);
    storage.setItem('blockDate.' + blockNumber, block.timestamp);
    return date;
}

 
